
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TechnologyFocusSection from './components/TechnologyFocusSection';
import AdvantageSection from './components/AdvantageSection';
import CTASection from './components/CTASection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-black relative">
      <Header />
      
      <div className="relative">
        <HeroSection />
        <ServicesSection />
        <TechnologyFocusSection />
        <AdvantageSection />
        <CTASection />
      </div>
      
      <Footer />
    </div>
  );
};

export default Home;
